import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
import { selectors as paymentDataSelectors } from 'state/paymentData';
import { useTranslation } from 'react-i18next';
import { gridSizes, media, weights } from 'utils/style';
import { useSoFormStepsApi, useSoFormStepsState } from '../../SoForm.context';
import PaymentData from 'components/PaymentData/component';

const SoFormPaymentForm = ({ className }) => {
  const stepsState = useSoFormStepsState();
  const stepsApi = useSoFormStepsApi();
  const { t } = useTranslation('PaymentData');

  const quote = stepsState.activeQuote;
  const country = useSelector(settingsSelectors.getCountrySettings);
  const fullPrice = Number(quote?.gross_full_price) | 0;
  const hasQuoteError = false;
  const isSubmitting = stepsState.payment.isLoading;
  const hasPastError = false;
  const hasErrors = false;
  const paymentData = useSelector(paymentDataSelectors.getPaymentData);

  const submitPaymentData = () => {
    stepsApi.onPaymentSubmit();
  };

  return (
    <div className={className}>
      <PaymentData
        country={country}
        fullPrice={fullPrice}
        hasQuoteError={hasQuoteError}
        isSubmitting={isSubmitting}
        hasPastError={hasPastError}
        hasErrors={hasErrors}
        paymentData={paymentData}
        t={t}
        submitPaymentData={submitPaymentData}
      />
    </div>
  );
};

SoFormPaymentForm.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormPaymentForm)`
  .summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 32px;

    button {
      min-width: 30%;
      text-transform: uppercase;
    }
  }

  .error {
    color: var(--red-cherry-text);
  }

  .vat-value {
    font-size: ${gridSizes('M')};
    color: var(--grey900);
    font-weight: ${weights('regular')};
    margin: 0;
    text-align: right;

    .price {
      text-align: left;
      font-weight: ${weights('medium')};
      color: var(--grey900);
      font-size: 3.2rem;
    }

    ${media.lessThan('medium')`
    text-align: left;
  `};
  }

  .error {
    margin: ${gridSizes('M')} 0;
    font-size: ${gridSizes('M')};
    font-weight: 500;
    color: #cc000a;
  }
`;
